import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "aa_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: API, timeout: 120000 });

adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Admin-Token"] = t;
  return config;
});

export const adminLogin = (password) =>
  adminApi.post("/admin/login", { password }).then((r) => r.data);
export const adminVerify = () => adminApi.get("/admin/verify").then((r) => r.data);

// leads
export const getLeads = (status = "all") =>
  adminApi.get("/leads", { params: { status } }).then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  adminApi.patch(`/admin/leads/${id}`, { status }).then((r) => r.data);
export const deleteLead = (id) =>
  adminApi.delete(`/admin/leads/${id}`).then((r) => r.data);

// blog
export const getBlogOverview = () =>
  adminApi.get("/admin/blog-overview").then((r) => r.data);
export const generateBlog = (body) =>
  adminApi.post("/admin/generate-blog", body).then((r) => r.data);
export const createCustomBlog = (body) =>
  adminApi.post("/admin/custom-blog", body).then((r) => r.data);
export const regenerateCustomBlog = (slug) =>
  adminApi.post(`/admin/custom-blog/${slug}/regenerate`).then((r) => r.data);
export const deleteBlog = (slug) =>
  adminApi.delete(`/admin/blogs/${slug}`).then((r) => r.data);
export const getJob = (id) => adminApi.get(`/admin/jobs/${id}`).then((r) => r.data);
export const getJobs = (limit = 10) =>
  adminApi.get("/admin/jobs", { params: { limit } }).then((r) => r.data);

// media
export const getMedia = (kind) =>
  adminApi.get("/admin/media", { params: kind ? { kind } : {} }).then((r) => r.data);
export const uploadMedia = (kind, files, onProgress) => {
  const form = new FormData();
  Array.from(files).forEach((f) => form.append("files", f));
  return adminApi
    .post(`/admin/media/upload?kind=${kind}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300000,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => r.data);
};
export const updateMedia = (id, body) =>
  adminApi.patch(`/admin/media/${id}`, body).then((r) => r.data);
export const reorderMedia = (ids) =>
  adminApi.patch("/admin/media/reorder", { ids }).then((r) => r.data);
export const deleteMedia = (id) =>
  adminApi.delete(`/admin/media/${id}`).then((r) => r.data);

// notifications
export const getNotificationStatus = () =>
  adminApi.get("/admin/notifications/status").then((r) => r.data);
export const sendTestEmail = (to) =>
  adminApi.post("/admin/notifications/test", { to: to || null }).then((r) => r.data);

// site settings (contact info)
export const getSiteSettings = () =>
  adminApi.get("/admin/site-settings").then((r) => r.data);
export const updateSiteSettings = (body) =>
  adminApi.put("/admin/site-settings", body).then((r) => r.data);
export const resetSiteSettings = () =>
  adminApi.delete("/admin/site-settings").then((r) => r.data);
